var _path, _path2, _path3, _path4, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocuments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.425 15.0645C58.0819 15.0645 59.425 16.4076 59.425 18.0645V73.9992C59.425 75.6561 58.0819 76.9992 56.425 76.9992H19.7402C18.0834 76.9992 16.7402 75.6561 16.7402 73.9992V18.0645C16.7402 16.4076 18.0834 15.0645 19.7402 15.0645L56.425 15.0645Z",
    fill: "url(#paint0_linear_8224_3468)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0559 7.53223C49.7127 7.53223 51.0559 8.87537 51.0559 10.5322V66.467C51.0559 68.1239 49.7127 69.467 48.0559 69.467H11.3711C9.71424 69.467 8.37109 68.1239 8.37109 66.467V10.5322C8.37109 8.87537 9.71424 7.53223 11.3711 7.53223L48.0559 7.53223Z",
    fill: "url(#paint1_linear_8224_3468)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1882 0.890613C14.7517 0.320708 15.5199 0 16.3214 0H39.6848C41.3416 0 42.6848 1.34315 42.6848 3V58.9348C42.6848 60.5916 41.3416 61.9348 39.6848 61.9348H3C1.34314 61.9348 0 60.5916 0 58.9348V16.4717C0 15.6819 0.311468 14.9239 0.866813 14.3623L14.1882 0.890613Z",
    fill: "url(#paint2_linear_8224_3468)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8224_3468",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 43,
    height: 62
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1882 0.890613C14.7517 0.320708 15.5199 0 16.3214 0H39.6848C41.3416 0 42.6848 1.34315 42.6848 3V58.9348C42.6848 60.5916 41.3416 61.9348 39.6848 61.9348H3C1.34314 61.9348 0 60.5916 0 58.9348V16.4717C0 15.6819 0.311468 14.9239 0.866813 14.3623L14.1882 0.890613Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8224_3468)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 15.9022,
    height: 2.51087,
    rx: 1.25543,
    transform: "matrix(1 0 0 -1 7.5332 24.2715)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 26.7826,
    height: 2.51087,
    rx: 1.25543,
    transform: "matrix(1 0 0 -1 7.5332 30.9678)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8224_3468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0652 0V15.1677H0L15.0652 0Z",
    fill: "#A6E2EB"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8224_3468",
    x: -10,
    y: -8,
    width: 35.0645,
    height: 35.168,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0928159 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8224_3468"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8224_3468",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8224_3468",
    x1: 20.3083,
    y1: 89.0672,
    x2: 75.0246,
    y2: 72.5451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AB8C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEF7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8224_3468",
    x1: 15.3252,
    y1: 95.1032,
    x2: 72.8689,
    y2: 72.3802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C9CB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3E2EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8224_3468",
    x1: -11.911,
    y1: 27.5717,
    x2: 41.8328,
    y2: 69.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C9CB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3E2EB"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.4fd2a022e54f5b9482c6b28b768ff32a.svg";
export { ForwardRef as ReactComponent };